import { render, staticRenderFns } from "./ShowHome.vue?vue&type=template&id=1a05700a"
import script from "./ShowHome.vue?vue&type=script&lang=js"
export * from "./ShowHome.vue?vue&type=script&lang=js"
import style0 from "./ShowHome.vue?vue&type=style&index=0&id=1a05700a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports